module.exports = require('./browser/algorithms.json')



//////////////////
// WEBPACK FOOTER
// ./~/browserify-sign/algos.js
// module id = 319
// module chunks = 0